import { IntlFormatters } from 'react-intl';

// Non-TH doesn't display an error

export const getBillingCountryError = (_: IntlFormatters['formatMessage']) => '';
